document.addEventListener('DOMContentLoaded', function () {

    // selectionner les boutons ajouter
    const addElementsButtons = document.querySelectorAll('.addButton');

    // si ils existents, leur ajouter un ecouteur d'evenement
    if (addElementsButtons !== null) {
        for (const addElementsButton of addElementsButtons) {

            // au click sur ajouter, recuperer la position du curseur et le contenu du textarea
            addElementsButton.addEventListener('click', (event) => {
                const textarea = document.querySelector('.textarea');
                const [cursorPositionStart, cursorPositionEnd, textareaValue] = [textarea.selectionStart, textarea.selectionEnd, textarea.value];
                console.log('array',[cursorPositionStart, cursorPositionEnd, textareaValue])

                // fonction qui générera le nouveau contenu du textarea
                const insertNewTextarea = (cursorStart, cursorEnd, text, link) => {
                    const newText = text.slice(0, cursorStart) + link + text.slice(cursorEnd);
                    textarea.value = newText;
                }

                // récupérer la modale correspondant au bouton cliqué
                const targetId = event.target.id;
                const activeModalId = targetId.slice(0, targetId.length - 6);
                const activeModal = document.querySelector(`#${activeModalId}`);
                const button = activeModal.querySelector('.insertButton');

                // Vider les inputs de la modale au cas où ils ont déjà été remplis auparavant:
                const inputContent = activeModal.querySelectorAll('.insertInput');
                for (const input of inputContent) {
                    input.value = '';
                }

                // Si on a cliqué sur addImageButton, on verifie si il y a une div d'erreur dans le dom. Si oui, on la supprime.
                if (targetId === 'addImageButton') {
                    const errorDiv = document.querySelector('#imageError')
                    if (errorDiv) {
                        errorDiv.remove()
                    }
                }

                // au clic sur le bouton insérer de la modale :
                button.addEventListener('click', (event) => {
                    event.preventDefault();
                    let insertString;


                    if (targetId !== 'addImageButton' || (targetId === 'addImageButton' && inputContent[0].value.length)) {

                        // Je génère la string à insérer dans la textarea
                        switch (targetId) {
                            case 'addLinkButton' :
                                insertString = `[LIEN=${inputContent[0].value}]${inputContent[1].value}[/LIEN]`;
                                break;

                            case 'addImageButton' :
                                insertString = `[IMAGE=${inputContent[0].value}]`;
                                break;

                            case 'addVideoButton' :
                                insertString = `[VIDEO=${inputContent[0].value}]`;
                                break;
                        }

                        // Je génère le nouveau texte de la textarea et je l'insère dans le DOM
                        insertNewTextarea(cursorPositionStart, cursorPositionEnd, textareaValue, insertString);

                    } else {
                        // Si l'user upload une image locale

                        // Je récupère le fichier
                        const inputFile = document.getElementById('imageFile')

                        // Je vérifie que son extension soit valide
                        const fileName = inputFile.value
                        console.log(fileName)

                        if (fileName.endsWith('.jpg') || fileName.endsWith('.jpeg') || fileName.endsWith('.png')) {
                            // Si oui, je l'enregistre dans un dossier temporaire
                            async function uploadFile() {
                                let formData = new FormData();
                                formData.append("file", inputFile.files[0]);

                                const response = await fetch('/api/v1/discussion/image', {
                                    method: 'POST',
                                    body: formData
                                })

                                return response.json()
                            }

                            uploadFile()
                                .then((response) => {
                                    // Je génère le nouveau texte de la textarea et je l'insère dans le DOM
                                    insertString = `[IMAGE_TEMP=${response}/IMAGE_TEMP]`;
                                    insertNewTextarea(cursorPositionStart, cursorPositionEnd, textareaValue, insertString);
                                })

                                .catch((error) => {
                                    console.log('Erreur ! ' + error)
                                })
                        } else {

                            // Si non, j'affiche une erreur
                            const messageArea = document.querySelector('#messageWrapper')
                            const error = document.createElement('p')

                            error.id = 'imageError'
                            error.classList.add('fst-italic')
                            error.classList.add('text-danger')
                            error.textContent = 'Attention ! Votre image doit être au format .png, .jpeg ou .jpg'

                            messageArea.appendChild(error)

                            setTimeout(function () {
                                error.remove()
                            }, 5000)
                        }
                    }
                })
            })
        }
    }
})
